<template>
  <v-container class="pa-0" fluid v-resize="resizeTable">
    <v-card flat>
      <v-flex>
        <v-card-text>
          <v-data-table
            :mobile-breakpoint="0"
            :headers="headers.map((item) => ({ ...item, text: $t(item.text) }))"
            fixed-header
            :items="editedOrganization.settings.rasterSources"
            item-key="id"
            :options.sync="pagination"
          >
            <template v-slot:item.name="{ value }">
              <span>{{ value }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <gli-editor-button
                    class="ml-2"
                    color="primary"
                    fab
                    x-small
                    dark
                    v-on="on"
                    @click="editRasterSource(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </gli-editor-button>
                </template>
                <span>{{ $t('Edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <gli-editor-button
                    class="ml-2"
                    color="error"
                    fab
                    x-small
                    dark
                    v-on="on"
                    @click="deleteRasterSource(item._id)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </gli-editor-button>
                </template>
                <span>{{ $t('Delete') }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-flex>

      <v-card-actions class="mr-2">
        <v-spacer></v-spacer>
        <gli-editor-button small color="primary" @click="addNewRasterSource">{{
          $t('New raster source')
        }}</gli-editor-button>
      </v-card-actions>
    </v-card>

    <raster-source-dialog v-if="editedRasterSource"></raster-source-dialog>
  </v-container>
</template>

<style lang="scss" scoped></style>
<script>
import RasterSourceDialog from './RasterSourceDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import resizeTable from '../mixins/resizeTable';

export default {
  name: 'RasterSources',
  props: [],

  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Url',
          value: 'url'
        },
        {
          text: 'Description',
          value: 'description'
        },
        {
          text: '',
          value: 'actions',
          width: 232,
          sortable: false,
          align: 'end'
        }
      ],
      pagination: {
        page: 1
      }
    };
  },

  computed: {
    ...mapGetters('organization', ['editedOrganization', 'editedRasterSource'])
  },

  mounted() {},
  methods: {
    ...mapActions('organization', ['addNewRasterSource', 'editRasterSource', 'deleteRasterSource'])
  },
  mixins: [resizeTable],
  components: { RasterSourceDialog }
};
</script>
